export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/modelIconGreen.8788dc47.svg","height":12,"width":26,"blurWidth":0,"blurHeight":0};